<template>
  <div class="map">
    <a :name="'mapPanelTop'"></a>
    <div
      v-show="showMapPanel || showSearchPanel"
      class="z-10 w-full"
      :class="showMapPanel ? 'absolute' : 'sticky'">
      <search-form
        @search="onSearch"
        @incrementSearch="onIncrementSearch"
        @closeSearchPanel="onCloseSearchPanel"
        @openFilterPanel="onOpenFilterPanel"
        :onSearch="showSearchPanel"
      />
    </div>
    <div v-show="showMapPanel" class="h-full w-full">
      <map-panel
        @search="onSearch"
        @closeSearchPanel="onCloseSearchPanel"
        @openFilterPanel="onOpenFilterPanel"
        :zoomLevel="zoomLevel"
      />
    </div>
    <div v-show="showSearchPanel" class="h-full w-full pb-4">
      <search-panel
        @openGenreList="onOpenGenreList"
        @selectGenre="onSelectGenre"
        :genre="genre"
        :searchWord="searchWord"
      />
    </div>
    <div v-show="showGenreList" class="h-full w-full pb-4">
      <genre-list
        @close="onCloseGenreList"
        @selectGenre="onSelectGenre"
      />
    </div>
    <div v-show="showFilterPanel" class="h-full w-full pb-4">
      <filter-panel
        @close="onCloseFilterPanel"
      />
    </div>
    <div v-show="showDocomoMobaku" class="h-full w-full pb-4">
      <docomo-mobaku/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

import SearchForm from '../components/organisms/Map/SearchForm'
import SearchPanel from '../components/organisms/Map/SearchPanel'
import GenreList from '../components/organisms/Map/GenreList'
import FilterPanel from '../components/organisms/Map/FilterPanel'
import MapPanel from '../components/organisms/Map/MapPanel'
import DocomoMobaku from '../components/organisms/Map/DocomoMobaku'

export default {
  beforeRouteEnter (route, redirect, next) {
    const p = {
      name: redirect.name,
      params: redirect.params,
      route: route.params.route
    }
    next((vm) => {
      vm.$store.dispatch('map/updateFrom', p)
      if (p.route) {
        const fromLocation = p.route.points[0].location
        const center = {
          lat: fromLocation.latitude,
          lng: fromLocation.longitude
        }
        vm.$store.dispatch('map/updateCenter', center)
      }
    })
  },
  created () {
    this.$store.dispatch('loading/beginLoading')
    this.$store.dispatch('drawer/close')
    this.$store.dispatch('reservation/deactivateMode')
    this.$store.dispatch('genres/fetchAll')
      .then(() => {
        if (this.$route.params.poiId !== undefined) {
          this.$store.dispatch('places/fetchPlace', this.$route.params.poiId).then((poi) => {
            if (poi) {
              const g = Object.values(poi.tags)[0]
              const icon = g && g.img ? g.img : ''
              const fetchPlace = {
                id: poi.poi_id,
                name: poi.shop_name,
                name_yomi: poi.shop_name_yomi,
                location: {
                  latitude: parseFloat(poi.latitude),
                  longitude: parseFloat(poi.longitude)
                },
                address: poi.address,
                genreIds: Object.keys(poi.tags),
                genreWords: Object.values(poi.tags),
                image: poi.img_main,
                detail: poi.shop_introduction,
                zipcode: poi.zipcode,
                accessDetails: poi.access_details,
                phoneNumber: poi.phone_number,
                businessHour: poi.business_hours,
                regularHoliday: poi.regular_holiday,
                url: poi.url,
                mapIcon: icon,
                benefits: poi.benefits,
                priority: poi.priority,
                distance: poi.distance
              }
              if (this.$route.params.zoom) {
                const zoom = Number(this.$route.params.zoom)
                this.zoomLevel = zoom
              }
              this.$store.dispatch('drawer/openPlace', { place: fetchPlace, full: true })
              this.hiddenLoading = true
              setInterval(() => this.updatePlaces(), 200)
            }
          })
        } else {
          if (this.$route.params.tagId !== undefined) {
            // ジャンル指定
            var genres = this.$store.getters['user/getFilter']
            genres[this.$route.params.tagId] = true
            setInterval(() => this.updatePlaces(), 200)
          } else if (this.$route.name == 'current') {
            // 現在地中心
            if (!navigator.geolocation) {
              alert(this.$t('map_location_error_message'))
              return
            }
            this.$store.dispatch('geolocation/fetchLocation')
              .then(() => {
                const fromLocation = this.$store.getters['geolocation/getLocation']
                const center  = {
                  lat: fromLocation.lat,
                  lng: fromLocation.lng
                }
                this.$store.dispatch('map/updateCenter', center)
              })
              .catch(() => {
                const errorCode = this.$store.getters['geolocation/getErrorCode']
                this.handleError(errorCode)
              })
              .finally(() => {
                setInterval(() => this.updatePlaces(), 200)
              })
          } else if (this.$route.params.latLng) {
            // 指定された緯度経度を中心
            this.$store.dispatch('map/updateCenterLatLng', this.$route.params.latLng)
            setInterval(() => this.updatePlaces(), 200)
          } else {
            // 指定なし
            setInterval(() => this.updatePlaces(), 200)
          }
          this.$store.dispatch('drawer/updateSelectedPlace', {})
        }
        // お気に入り施設の取得
        if (this.token) {
          this.$store.dispatch('favorites/fetchAll').then(() => {
            const favoriteGenre = this.$store.getters['genres/getFavoriteGenre']
            if (favoriteGenre !== undefined) {
              const favorites = this.$store.getters['favorites/getFavorites']
              for (var i = 0; i < favorites.length; i++) {
                this.$store.dispatch('places/updateFavoritePlace', { id: favorites[i], favoriteId: favoriteGenre.id, favorited: true, favoriteIcon: favoriteGenre.filterIcon})
              }
              const genres = this.$store.getters['genres/getAll']
              this.$store.dispatch('user/updateFilter', genres)
            }
          })
        }
      })
      .finally(() => {
        this.$store.dispatch('loading/endLoading')
      })
  },
  components: {
    SearchForm,
    SearchPanel,
    GenreList,
    FilterPanel,
    MapPanel,
    DocomoMobaku
  },
  data () {
    return {
      showMapPanel: true,
      showSearchPanel: false,
      showGenreList: false,
      showFilterPanel: false,
      showDocomoMobaku: false,
      genre: {},
      searchWord: '',
      mobakuMessage: false,
      lastMapCenter: undefined,
      maxDistance: 0,
      zoomLevel: 15,
      placeLoading: false,
      hiddenLoading: false
    }
  },
  methods: {
    onSearch: function () {
      this.showSearchPanel = true
      this.showPlaceList = false
      this.showMapPanel = false
    },
    onCloseSearchPanel: function () {
      this.showSearchPanel = false
      this.showMapPanel = true
      this.genre = {}
    },
    onOpenGenreList: function () {
      this.showMapPanel = false
      this.showSearchPanel = false
      this.showGenreList = true
    },
    onCloseGenreList: function () {
      this.showGenreList = false
      this.showSearchPanel = true
    },
    onOpenFilterPanel: function () {
      this.showFilterPanel = true
      this.showSearchPanel = false
      this.showMapPanel = false
    },
    onCloseFilterPanel: function () {
      this.showMapPanel = true
      this.showFilterPanel = false
      var genres = this.$store.getters['user/getFilter']
      if (genres["mobaku"]) {
        this.$store.dispatch('googleMap/onDocomoMobaku')
        if(!this.mobakuMessage){
          this.mobakuMessage = true
          this.$store.dispatch('map/setShowDocomoMobaku', true)
        }
      } else {
        this.$store.dispatch('googleMap/offDocomoMobaku')
        this.mobakuMessage = false
      }
    },
    onSelectGenre: function (genre) {
      this.genre = genre
      this.showGenreList = false
      this.showSearchPanel = true
      location.hash = '#mapPanelTop'
    },
    onIncrementSearch: function (word) {
      this.searchWord = word
    },
    handleError: function (errorCode) {
      switch (errorCode) {
        case 1: //PERMISSION_DENIED
          alert(this.$t('map_permission_denied_error_message'))
          break
        case 2: //POSITION_UNAVAILABLE
          alert(this.$t('map_position_unavailable_error_message'))
          break
        case 3: //TIMEOUT
          alert(this.$t('map_timeout_error_message'))
          break
        default:
          alert(this.$t('map_default_error_message'))
          break
      }
    },
    updatePlaces: function () {
      if (this.$store.getters['user/getLang'] !== null) {
        if (this.lastMapCenter === undefined) {
          this.getPlaces()
        } else {
          const distance = this.getDistance(this.lastMapCenter.lat, this.lastMapCenter.lng, this.center.lat, this.center.lng)
          if (!this.placeLoading && distance > this.maxDistance) {
            this.getPlaces()
          }
        }
      }
    },
    getPlaces: function () {
      if (!this.hiddenLoading) {
        this.$store.dispatch('loading/beginLoading')
      }
      this.placeLoading = true
      this.lastMapCenter = Object.assign({}, this.center)
      this.$store.dispatch('places/fetchAll')
        .then(() => {
          this.setMaxDistance()
          this.placeLoading = false
          const genres = this.$store.getters['genres/getAll']
          this.$store.dispatch('user/updateFilter', genres)
          if (this.token) {
            const favoriteGenre = this.$store.getters['genres/getFavoriteGenre']
            if (favoriteGenre !== undefined) {
              const favorites = this.$store.getters['favorites/getFavorites']
              for (var i = 0; i < favorites.length; i++) {
                this.$store.dispatch('places/updateFavoritePlace', { id: favorites[i], favoriteId: favoriteGenre.id, favorited: true, favoriteIcon: favoriteGenre.filterIcon})
              }
              this.$store.dispatch('user/updateFilter', genres)
            }
          }
          if (this.hiddenLoading) {
            this.hiddenLoading = false
          } else {
            this.$store.dispatch('loading/endLoading')
          }
        })
    },
    getDistance: function (lat1, lng1, lat2, lng2) {
      lat1 *= Math.PI / 180;
      lng1 *= Math.PI / 180;
      lat2 *= Math.PI / 180;
      lng2 *= Math.PI / 180;
      const d = 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2))
      return d;
    },
    setMaxDistance: function () {
      const places = this.$store.getters['places/getPlaces']
      for (let i = 0; i < places.length; i++) {
        if (places[i].distance !== undefined && places[i].distance > this.maxDistance) {
          this.maxDistance = places[i].distance
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      center: 'map/getCenter',
      selectedPlace: 'drawer/getSelectedPlace',
      token: 'user/getToken',
      docomoMobakuOn: 'map/getShowDocomoMobaku',
    })
  },
  watch: {
    selectedPlace: function (val) {
      if (!_.isEmpty(val)) {
        this.showSearchPanel = false
        this.showMapPanel = true
      }
    },
    docomoMobakuOn: function (val) {
      this.showDocomoMobaku = val
    }
  }
}
</script>
